"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSavedPayment = exports.SavedPaymentProvider = void 0;
const React = require("react");
const react_1 = require("react");
const idb_keyval_1 = require("idb-keyval");
const customStore = (0, idb_keyval_1.createStore)("ZamAppSettings", "ZamAppStore");
const PaymentContext = (0, react_1.createContext)(undefined);
const SavedPaymentProvider = ({ children }) => {
    const [selectedPaymentId, setSelectedPaymentIdState] = (0, react_1.useState)();
    const [isLoading, setLoading] = (0, react_1.useState)(true);
    const [error, setError] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        const loadPaymentId = async () => {
            try {
                const savedPaymentId = await (0, idb_keyval_1.get)("selectedPaymentId", customStore);
                setSelectedPaymentIdState(savedPaymentId);
                console.log("Got Saved Payment: " + savedPaymentId);
            }
            catch (err) {
                setError("Failed to load payment ID");
                console.error("Error loading payment ID from IndexedDB:", err);
            }
            setLoading(false);
        };
        loadPaymentId();
    }, []);
    const setSelectedPaymentId = async (id) => {
        try {
            await (0, idb_keyval_1.set)("selectedPaymentId", id, customStore);
            setSelectedPaymentIdState(id);
            console.log("Stored Saved Payment: " + id);
        }
        catch (err) {
            setError("Failed to update payment ID");
            console.error("Error updating payment ID in IndexedDB:", err);
        }
    };
    if (isLoading) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(PaymentContext.Provider, { value: { selectedPaymentId, setSelectedPaymentId, isLoading, error } }, children));
};
exports.SavedPaymentProvider = SavedPaymentProvider;
const useSavedPayment = () => {
    const context = (0, react_1.useContext)(PaymentContext);
    if (!context) {
        throw new Error("usePayment must be used within a PaymentProvider");
    }
    return context;
};
exports.useSavedPayment = useSavedPayment;
//# sourceMappingURL=SavedPaymentProvider.js.map